import { TGetClientsPageDataParams } from 'types/services';
import { TClientsPageData } from 'types/state';
import { m8API } from 'services/production/m8';
import { normalizeGetCleintsPageDataParams } from 'services/production/utils/normalizeGetCleintsPageDataParams';
import { normalizeM8UserFullInfo } from '../utils/normalizeM8UserFullInfo';

export const getClientsPageData = async (
  params: TGetClientsPageDataParams
): Promise<TClientsPageData> => {
  const request = (() => {
    if (params.mode === 'ACTIVE_CLIENTS') {
      return m8API.admin.getActiveUsers(
        normalizeGetCleintsPageDataParams(params).toM8GetUsersParams()
      );
    }

    return m8API.admin.getArchiveUsers(
      normalizeGetCleintsPageDataParams(params).toM8GetUsersParams()
    );
  })();

  const data = await request;

  return {
    totalPagesCount: data.totalPages,
    clients: data.content.map((item) =>
      normalizeM8UserFullInfo(item).toClientsTableItem()
    ),
  };
};
